import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=b6b01356&scoped=true"
import script from "./UpdateContact.vue?vue&type=script&lang=js"
export * from "./UpdateContact.vue?vue&type=script&lang=js"
import style0 from "./UpdateContact.vue?vue&type=style&index=0&id=b6b01356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b01356",
  null
  
)

export default component.exports